import React from "react";

const LoadingSaveForm = ({ updateBeforeSave }) => {
  return (
    <div className={`loading-save-form-container ${updateBeforeSave.mode ? "acitve" : "not-active"}`}>
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    </div>
  );
};

export default LoadingSaveForm;
